import { render, staticRenderFns } from "./AppCountdown.vue?vue&type=template&id=1436d682&"
import script from "./AppCountdown.vue?vue&type=script&lang=js&"
export * from "./AppCountdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports